import { useTranslation } from "react-i18next";
import { ColumnLevelFilter } from "../../../page/ProductsPage/ColumnLevelFilter";
import { useNotificationSelectList } from "../../../services/agreementsService";

/**
 * Reusable notification filter component that fetches notifications
 * and displays them in a dropdown filter
 */
export const NotificationFilter = (props) => {
    const { searchParams, setSearchParams, filterName, InputLabelStyle, maxHeight } = props;
    const { t } = useTranslation();
    const { data: notifications } = useNotificationSelectList();

    const notificationOptions = notifications || [];
    const columnValues = notificationOptions.map((notification) => notification.id);
    const columnDisplayValues = notificationOptions.map(
        (notification) => notification.notification_name,
    );

    return (
        <ColumnLevelFilter
            label={t("drafts.columns.notificationType")}
            columnValues={columnValues}
            columnDisplayValues={columnDisplayValues}
            columnName={filterName || "draft_notification"}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
            InputLabelStyle={InputLabelStyle}
            maxHeight={maxHeight}
        />
    );
};